import React, {useState} from 'react';
import {LoadingIcon} from "./Ui/LoadingIcon";
import {GoogleMap} from "./Map/GoogleMap";
import {MapList} from "./Map/MapList";
import {Bounds} from 'google-map-react';
import {useInBounds} from "../hooks/useInBounds";
import {Location} from "../types/location";
import {AppState} from "../enum/appState";
import {FilterOption} from "../types/filterOption";
import {LocationFilter} from "./Map/LocationFilter";
import {OptionsType} from "react-select";
import {UpdateFilterCallback} from "../types/updateFilterCallback";
import {NoResultMessage} from "./Ui/NoResultMessage";
import {Filter} from "../types/filter";
import {Mode} from "../enum/mode";


type LocationMapProps = {
    locations: Location[],
    appState: AppState,
    selectedLocation: Location | null,
    setSelectedLocation: (offer: Location|null) => void
    categories: OptionsType<FilterOption>,
    updateFilter: UpdateFilterCallback,
    filter: Filter,
    mode: Mode
}

export function LocationMap({locations, appState, selectedLocation, setSelectedLocation, categories, updateFilter, filter, mode} : LocationMapProps) {

    const [bounds, setBounds] = useState<Bounds | undefined>(undefined);
    const [mapHoverLocation, setMapHoverLocation] = useState<Location|null>(null);

    const locationsInBound = useInBounds(locations, bounds);

    return (
        <div className="locationMap">
            <>
                {appState === AppState.loading && <LoadingIcon />}

                <div className={'locationMapContainer'}>

                    <GoogleMap
                        locations={locations}
                        onBoundChange={(bounds : Bounds) => setBounds(bounds)}
                        selectedLocation={selectedLocation}
                        setSelectedLocation={setSelectedLocation}
                        mapHoverLocation={mapHoverLocation}
                        setMapHoverLocation={setMapHoverLocation}
                        mode={mode}
                    />

                    { mode !== Mode.SINGLE && (
                        <>
                            <LocationFilter filter={filter} categories={categories} updateFilter={updateFilter}/>

                            {appState === AppState.ready && locations.length === 0 && <NoResultMessage />}
                        </>
                    )}

                    <MapList
                        locations={locationsInBound}
                        mapHoverLocation={mapHoverLocation}
                        mapSelectLocation={selectedLocation}
                        mode={mode}
                    />
                </div>
            </>
        </div>
    );
}
